//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { GalleriesActionBarActionType } from '@galleries/actions/galleriesActionBarActions';
import { GALLERIES_ACTIONS } from '@galleries/constants/galleriesConstants';
import {
  IGalleriesActionBar,
  SOURCE_FILTER_VALUES,
} from '@galleries/models/galleriesStateModel';
import { getAliasedDateRange } from '@components/date-range-picker/dateRangePickerModels';
import TimeZoneId from '@models/TimeZoneId';
import { crl8 } from 'app/curalate.globals';

const initialState: IGalleriesActionBar = {
  searchFilterValue: '',
  sourceFilterValue: SOURCE_FILTER_VALUES.ALL_MEDIA,
  dateRange: getAliasedDateRange(
    'allTime',
    crl8.session?.timeZone.id ?? TimeZoneId.Utc,
  ),
};

export default function GalleriesActionBarReducer(
  state: IGalleriesActionBar = initialState,
  action: GalleriesActionBarActionType,
) {
  switch (action.type) {
    case GALLERIES_ACTIONS.UPDATE_SEARCH_VALUE: {
      return {
        ...state,
        searchFilterValue: action.searchText,
      };
    }
    case GALLERIES_ACTIONS.UPDATE_SOURCES_VALUE: {
      const dateRangeValue = getAliasedDateRange(
        'allTime',
        crl8.session?.timeZone.id ?? TimeZoneId.Utc,
      );
      return {
        ...state,
        sourceFilterValue: action.value,
        dateRange: dateRangeValue,
      };
    }

    case GALLERIES_ACTIONS.UPDATE_DATE_RANGE_VALUE: {
      return {
        ...state,
        dateRange: action.dateRange,
      };
    }
    default:
      return state;
  }
}
